const _ = require('lodash');

/**
 * Verica que el valor sea o no un arreglo
 * @param {*} valor 
 * @returns 
 */
 const isArray = valor =>{
    return Array.isArray(valor);
}

/**
 * Valida que el arreglo no esté vacío
 * @param {*} valor 
 * @returns 
 */
const isEmpty = valor =>{
    return _.isEmpty( valor );
}

const sortByElement = (arrayData,element)=>{
    try {
        return _(arrayData).sortBy(x=> x[element]).value();
    } catch (error) {
        console.error(error);
        return null;
    }
}

export const arrayFunctionHelpers = { 
    isArray: isArray,
    isEmpty: isEmpty,
    sortByElement: sortByElement
}